import { render, staticRenderFns } from "./document-appendices.vue?vue&type=template&id=239bc477&scoped=true&"
import script from "./document-appendices.vue?vue&type=script&lang=js&"
export * from "./document-appendices.vue?vue&type=script&lang=js&"
import style0 from "./document-appendices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bc477",
  null
  
)

export default component.exports